import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindProductTypesRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindProductTypesRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindProductTypesRequestSortsDto>>
}

export const ProductTypesSort = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("admin")
  return (
    <SortBuilder<FindProductTypesRequestSortsDto>
      sorts={sorts}
      setSorts={setSorts}
      options={[
        {
          label: t("productTypes.sort.originalText"),
          value: "originalText",
        },
        {
          label: t("productTypes.sort.operationChainName"),
          value: "operationChainName",
        },
      ]}
    />
  )
}
